import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appRestrictSpecialChars]'
})
export class RestrictSpecialCharsDirective {

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const value = this.ngControl.value as string;
    const array = ['+','=','-','`','~','_','\\','/',']','[']
    // Remove special characters and multiple spaces
    let sanitizedValue = value.replace(/[!@#$%^&*(),.?":{}|<>]/g, '').replace(/\s{2,}/g, ' ');
    array.forEach((notAllowed:string)=>{
      sanitizedValue = sanitizedValue.replace(notAllowed,'');
    });
    if(sanitizedValue.length === 1 && (+sanitizedValue || (+sanitizedValue === 0))){
      sanitizedValue = '';
    }
    // Update the control value with the sanitized value
    this.ngControl.control?.setValue(sanitizedValue, { emitEvent: false });
  }

}
